import React from 'react';
import { Formik, Form, Field } from 'formik';
import { ConfigProvider, Table } from 'antd';
import { IProps, IState, IFormValue, ITableDataSource, TempPolicyInquiry } from './types';
import { DatePicker } from 'formik-antd';
import { ColumnProps } from 'antd/es/table';
// import moment from 'moment';
import moment from 'moment-timezone';
import { PaginationTypes, SortTypes } from 'constants/models/tableTypes';
import service from 'bff/services/policyInquiryService';
import { FieldContent, FieldOptContent, PolicyQueryDataContent } from 'bff/models/member';
import { FID, HandleType, InquiryDefault, QClass, RefFrom } from 'constants/enums/policyInquiry.enum';
import _ from 'lodash';
import HandleTypeDefines from 'constants/models/handleTypeDefines';
import { InsType } from 'constants/enums/insType.enum';
import { RouterSettings } from 'constants/models/routerSettings';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import { Pagination } from 'bff/models/base/pagination';
import sweetAlertService from 'utils/sweetAlertService';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import commonService from 'utils/commonService';
import { CodeId } from 'constants/enums/codeId.enum';
import { RootReducersState } from 'redux/reducers';
import { connect } from 'react-redux';
import enUS from 'antd/es/locale/en_US';
import zhTW from 'antd/es/locale/zh_TW';

/** 選項值與 TID 對照表 */
const valueTidMap = [
  { value: 'ALL', TID: 'TID_All' },
  { value: 'A', TID: 'TID_All' },
  { value: '1', TID: 'TID_Pending' },
  { value: '2', TID: 'TID_Processing' },
  { value: '5', TID: 'TID_Delivered' },
  { value: '6', TID: 'TID_Canceled' },
  { value: 'I01', TID: 'TID_Travel_insurance' },
  { value: 'I02', TID: 'TID_Car_Insurance' },
  { value: 'I03', TID: 'TID_Motorcycle_Insurance' },
  { value: 'I04', TID: 'TID_Fire_Insurance' },
  { value: 'I05', TID: 'TID_Mobile_phone_insurance' },
  { value: 'I06', TID: 'TID_Pet_Insurance' }
];
const selectAll = InquiryDefault.SELECT_ALL as string;
const defaultPage = InquiryDefault.PAGE as number;
const defaultPageSize = InquiryDefault.PAGE_SIZE as number;

const initFormVal: IFormValue = {
  EFFECTIVE_DATE: new Array(0),
  INS_TYPE: selectAll,
  POLICY_STATUS: selectAll
};

let formInitialValues = initFormVal;

const initState: IState = {
  codeTables: [],
  UICodes: [],
  activePage: defaultPage,
  activePageSize: defaultPageSize,
  fieldInfos: new Array(0),
  policyDatas: {
    TOTAL: 0,
    DATA: new Array(0)
  },
  dataSources: new Array(0),
  tempFormVal: {
    EFFECTIVE_DATE: '',
    INS_TYPE: '',
    POLICY_STATUS: ''
  }
};

class PolicyInquiry extends React.Component<IProps, IState> {
  private formikRef: any = React.createRef();

  state: IState = initState;

  componentDidMount = async () => {
    if (storageService.getItem(storageKeys.PolicyInquiry)) {
      const tempPolicyInquiry = JSON.parse(storageService.getItem(storageKeys.PolicyInquiry)) as TempPolicyInquiry;

      formInitialValues = {
        ...formInitialValues,
        ...tempPolicyInquiry.tempPolicyInquiryFormValue,
        EFFECTIVE_DATE: _.map(tempPolicyInquiry.tempPolicyInquiryFormValue.EFFECTIVE_DATE, (range: any) => moment(range))
      };

      this.setState(prevState => {
        return {
          ...prevState,
          ...tempPolicyInquiry.tempPolicyInquiryState
        };
      });

      await this.handleInquiry(
        tempPolicyInquiry.tempPolicyInquiryState.activePage,
        tempPolicyInquiry.tempPolicyInquiryState.activePageSize,
        formInitialValues);

      storageService.removeItem(storageKeys.PolicyInquiry);
      // 根據語系取得 code
      const initSettingRes = await service.fetchInitSetting(this.props.resources.lng);
      this.setState({
        ..._.cloneDeep(this.state),
        codeTables: [...initSettingRes.codeTables],
        UICodes: [...initSettingRes.UICodes]
      });
      return;
    }
    const initSettingRes = await service.fetchInitSetting(this.props.resources.lng);
    const fieldInfos = await service.fetchInquiryFilter(QClass.FILTER_FEMP);

    if (!fieldInfos) return;

    this.setState({
      codeTables: [...initSettingRes.codeTables],
      UICodes: [...initSettingRes.UICodes],
      fieldInfos: [...fieldInfos]
    });
  }

  componentDidUpdate = async (prevProps: IProps) => {
    if (this.props.resources.lng !== prevProps.resources.lng) {
      const initSettingRes = await service.fetchInitSetting(this.props.resources.lng);
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        ..._.cloneDeep(this.state),
        codeTables: [...initSettingRes.codeTables],
        UICodes: [...initSettingRes.UICodes]
      });
    }
  }

  /**
   * @description 清除查詢區塊
  */
  handleResetForm = (resetForm: any) => {
    resetForm({
      values: { ...initFormVal }
    });

    const { codeTables, UICodes, ...restInitState } = initState;
    this.setState({
      ...restInitState,
      fieldInfos: this.state.fieldInfos,
      tempFormVal: {
        EFFECTIVE_DATE: '',
        INS_TYPE: '',
        POLICY_STATUS: ''
      }
    });
  }

  /**
   * @description 表單 Submit 方法
  */
  handleFormSubmit = async (values: IFormValue) => {
    await this.handleInquiry(defaultPage, this.state.activePageSize, values);
    this.setState(prevState => {
      return {
        ...prevState,
        tempFormVal: { ...values }
      };
    });
  }

  /**
   * @description Table Change 事件
  */
  handleTableChange = async (pagination: PaginationTypes, filter: any, sorter: any) => {
    await this.handleInquiry(pagination.current, pagination.pageSize, this.state.tempFormVal);
  }

  /**
   * @description 依查詢條件取得查詢結果值
  */
  handleInquiry = async (pageNo: number, pageSize: number, values: IFormValue) => {
    const queryReq = this.handleGetQueryReq(values);

    const sorter = {
      columnKey: 'START_DATE',
      order: 'desc'
    };

    const paginationReq = this.handleGetPaginationReq(pageNo, pageSize, sorter as SortTypes);

    const res = await service.policyQuery(queryReq, paginationReq);
    // console.log('res', res);
    if (res && res.DATA && res.DATA.length > 0) {
      this.setState(prevState => {
        return {
          ...prevState,
          policyDatas: { ...res },
          activePage: pageNo,
          activePageSize: pageSize,
          dataSources: this.handleGetDataSources(res.DATA)
          // selectedRowKeys: new Array(0),
          // selectedRows: new Array(0)
        };
      });
    } else {
      this.setState(prevState => {
        return {
          ...prevState,
          policyDatas: initState.policyDatas,
          activePage: defaultPage,
          activePageSize: defaultPageSize,
          dataSources: new Array(0)
        };
      });
    }
  }

  /**
   * @description 取得 Data Table 分頁資訊
   * @param pageNo 當前頁數
   * @param pageSize 當前顯示筆數
   * @param sorter 排序資訊
  */
  handleGetPaginationReq = (pageNo: number, pageSize: number, sorter?: SortTypes) => {
    let sorterKey = '';
    let sortOrderby = '';

    if (sorter && Object.keys(sorter).length > 0 && sorter.order) {
      sorterKey = sorter.columnKey;
      sortOrderby = sorter.order.startsWith('a') ? sorter.order.substring(0, 3).toUpperCase() : sorter.order.substring(0, 4).toUpperCase();
    }

    const paginationReq: Pagination = {
      SORT_PAGE: {
        PAGE: pageNo,
        SIZE: pageSize,
        SORT: sorterKey && sortOrderby ? { [sorterKey]: sortOrderby } : {}
      }
    };

    // console.log('paginationReq', paginationReq);
    return paginationReq;
  };

  /**
   * @description 取得查詢用 Request
  */
  handleGetQueryReq = (values: IFormValue) => {
    let startDate = '';
    let endDate = '';

    if (values.EFFECTIVE_DATE && values.EFFECTIVE_DATE.length > 0) {
      startDate = moment(values.EFFECTIVE_DATE[0]).format('YYYYMMDD');
      endDate = moment(values.EFFECTIVE_DATE[1]).format('YYYYMMDD');
    }

    return {
      START_DATE: startDate,
      // SDATE_S: startDate,
      END_DATE: endDate,
      // SDATE_E: endDate,
      INS_TYPE_ID: values.INS_TYPE,
      POLICY_STATUS: values.POLICY_STATUS
    };
  }

  /**
   * @description 取得表格資料內容
  */
  handleGetDataSources = (dataContents: PolicyQueryDataContent[]) => {
    return _.map(dataContents, (data: PolicyQueryDataContent, index: number) => {
      const handleBtns = [HandleType.Detail];
      if (data.RENEWAL_TRIGGER) {
        handleBtns.push(HandleType.RePolicy);
      }

      if (data.ENDROSE_TRIGGER) {
        handleBtns.push(HandleType.Modify);
      }

      return {
        ...data,
        TABLE_KEY: `${index + 1}`,
        HANDLE_BTNS: handleBtns
      } as ITableDataSource;
    });
  }

  /**
   * @description 取得 Data Table 分頁屬性
   * @param pageNo 當前頁數
   * @param pageSize 當前顯示筆數
   * @param totalCount 顯示總筆數
  */
  handleGetPaginationTypes = () => {
    const paginationTypes: PaginationTypes = {
      showSizeChanger: true,
      showQuickJumper: false,
      pageSize: this.state.activePageSize,
      pageSizeOptions: ['10', '20', '50', '100'],
      current: this.state.activePage,
      total: this.state.policyDatas.TOTAL
    };

    return paginationTypes;
  };

  /**
   * @description 各險種 (除旅平險) 檢查保單續保資料
   */
  checkRenewal = async (insTypeId: string, applyNo: string) => {
    const res = await service.memberPolicyCheckRenewal({ APPLY_NO: applyNo }, insTypeId);
    const result = res ? res.RESULT : false;
    if (res?.ERROR_MSG) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: res.ERROR_MSG
      });
    }
    return result;
  };

  /**
   * @description 我要辦理點選事件
  */
  handleProcess = async (type: string, dataSource: ITableDataSource) => {
    // console.log('type', type);
    // console.log('dataSource', dataSource);
    switch (type) {
      case HandleType.Detail: {
        await this.handleProcessDetail(dataSource.INS_TYPE_ID, dataSource.APPLY_NO);
        break;
      }
      case HandleType.Modify: {
        this.handleProcessModify(dataSource.INS_TYPE_ID, dataSource.APPLY_NO, dataSource.POLICY_NO, dataSource.RENEWAL_MARK);
        break;
      }
      case HandleType.RePolicy: {
        const result = dataSource.INS_TYPE_ID !== InsType.Travel && dataSource.INS_TYPE_ID !== InsType.Pet
          ? await this.checkRenewal(dataSource.INS_TYPE_ID, dataSource.APPLY_NO)
          : true;
        if (result) this.handleProcessRePolicy(dataSource.INS_TYPE_ID, dataSource.APPLY_NO);
        break;
      }
    }
  }

  /**
   * @description 導頁並暫存資料
   */
  handleRedirect = (path: any) => {
    const formVal = this.formikRef.current.values as IFormValue;

    const tempPolicyInquiry: TempPolicyInquiry = {
      handleType: HandleType.Detail,
      tempPolicyInquiryFormValue: { ...formVal },
      tempPolicyInquiryState: { ...this.state }
    };

    storageService.setItem(storageKeys.PolicyInquiry, (JSON.stringify(tempPolicyInquiry)));

    this.props.history.push(path);
  }

  /**
   * @description 辦理-明細查詢
  */
  handleProcessDetail = async (insTypeId: string, applyNo: string) => {
    if (!this.formikRef || !this.formikRef.current) return;

    const req = {
      APPLY_NO: applyNo,
      INS_TYPE_ID: insTypeId,
      REF_FROM: RefFrom.Detail
    };

    let pathName;
    let state;

    switch (insTypeId) {
      case InsType.Travel: {
        const detailInfo = await service.inquiryMemberDetail(insTypeId, req); // service.inquiryTravelDetail(insTypeId, req);
        if (!detailInfo) return;

        pathName = RouterSettings.MemberCenter.PolicyDetailTravel;
        state = { detailInfo: detailInfo, insTypeId: InsType.Travel };

        break;
      }
      case InsType.Car: {
        const detailInfo = await service.inquiryMemberDetail(insTypeId, req); // service.inquiryVehicleDetail(insTypeId, req);
        if (!detailInfo) return;

        pathName = RouterSettings.MemberCenter.PolicyDetailCar;
        state = { detailInfo: detailInfo, insTypeId: InsType.Car };

        break;
      }
      case InsType.Moto: {
        const detailInfo = await service.inquiryMemberDetail(insTypeId, req); // service.inquiryVehicleDetail(insTypeId, req);
        if (!detailInfo) return;

        pathName = RouterSettings.MemberCenter.PolicyDetailMoto;
        state = { detailInfo: detailInfo, insTypeId: InsType.Moto };

        break;
      }
      case InsType.Fire: {
        const detailInfo = await service.inquiryMemberDetail(insTypeId, req); // service.inquiryFireDetail(insTypeId, req);
        if (!detailInfo) return;

        pathName = RouterSettings.MemberCenter.PolicyDetailFire;
        state = { detailInfo: detailInfo, insTypeId: InsType.Fire };

        break;
      }
      case InsType.MobileDevice: {
        const detailInfo = await service.inquiryMemberDetail(insTypeId, req); // service.inquiryFireDetail(insTypeId, req);
        if (!detailInfo) return;

        pathName = RouterSettings.MemberCenter.PolicyDetailMobileDevice;
        state = { detailInfo: detailInfo, insTypeId: InsType.MobileDevice };

        break;
      }
      case InsType.Pet: {
        const detailInfo = await service.inquiryPetDetail(req); // service.inquiryFireDetail(insTypeId, req);
        if (!detailInfo) return;

        pathName = RouterSettings.MemberCenter.PolicyDetailPet;
        state = { detailInfo: detailInfo, insTypeId: InsType.Pet };
        break;
      }
      default:
        sweetAlertService.modal({
          icon: SweetAlertIcon.Info,
          html: '無法取得明細資料'
        });
        break;
    }

    if (!pathName || !state) return;

    const path = {
      pathname: pathName,
      state: state
    };

    this.handleRedirect(path);
  }

  /**
   * @description 辦理-續保
   */
  handleProcessRePolicy = async (insTypeId: string, applyNo: string) => {
    let pathName = '';
    let prodId = '';
    const detailInfo =
      insTypeId !== InsType.Pet
        ? await service.inquiryMemberDetail(insTypeId, { APPLY_NO: applyNo, INS_TYPE_ID: insTypeId, REF_FROM: RefFrom.Detail }) // 續保帶入相關資料;
        : '';

    switch (insTypeId) {
      case InsType.Car: {
        pathName = RouterSettings.InsureProcess.Car;
        prodId = 'AP3';
        storageService.removeItem(storageKeys.InsurceProcessCarState); // 續保需從第一步驟開始，因此清除投保流程暫存資料
        break;
      }
      case InsType.Moto: {
        pathName = RouterSettings.InsureProcess.Moto;
        prodId = 'AM4';
        storageService.removeItem(storageKeys.InsurceProcessMotoState); // 續保需從第一步驟開始，因此清除投保流程暫存資料
        break;
      }
      case InsType.Fire: {
        pathName = RouterSettings.InsureProcess.Fire;
        prodId = 'D';
        storageService.removeItem(storageKeys.InsurceProcessFireState); // 續保需從第一步驟開始，因此清除投保流程暫存資料
        break;
      }
      case InsType.MobileDevice: {
        pathName = RouterSettings.InsureProcess.MobileDevice;
        prodId = 'MPH';
        storageService.removeItem(storageKeys.InsurceProcessMobileDeviceState); // 續保需從第一步驟開始，因此清除投保流程暫存資料
        break;
      }
      case InsType.Pet: {
        pathName = RouterSettings.InsureProcess.Pet;
        prodId = '';
        storageService.removeItem(storageKeys.InsurceProcessPetState);
        break;
      }
      case InsType.Travel:
      default:
        sweetAlertService.modal({
          icon: SweetAlertIcon.Info,
          html: '無法續保'
        });
        break;
    }

    if (!pathName) return;
    const path = {
      pathname: pathName,
      state: {
        insTypeId: insTypeId,
        prodId: prodId,
        renewalInfo: detailInfo
      }
    };

    commonService.setActiveProdId(insTypeId, prodId);
    this.handleRedirect(path);
  }

  /**
   * @description 辦理-批改
   */
  handleProcessModify = (
    insTypeId: string, applyNo: string, policyNo: string, renewalMark?: string
  ) => {
    let pathName = '';

    switch (insTypeId) {
      case InsType.Travel: {
        pathName = RouterSettings.MemberCenter.CorrectionTravel;
        break;
      }
      case InsType.Car: {
        pathName = RouterSettings.MemberCenter.CorrectionCar;
        break;
      }
      case InsType.Moto: {
        pathName = RouterSettings.MemberCenter.CorrectionMoto;
        break;
      }
      case InsType.Fire: {
        pathName = RouterSettings.MemberCenter.CorrectionFire;
        break;
      }
      case InsType.MobileDevice:
      default:
        sweetAlertService.modal({
          icon: SweetAlertIcon.Info,
          html: '無法批改'
        });
        break;
    }

    if (!pathName) return;

    const path = {
      pathname: pathName,
      state: {
        insTypeId: insTypeId,
        policyNo: renewalMark || policyNo,
        applyNo: applyNo
      }
    };

    commonService.setActiveProdId(insTypeId);
    this.handleRedirect(path);
  }

  render () {
    const { fieldInfos } = this.state;

    /**
     * @description 判斷辦理按鈕是否可以點選
     */
    const setProcessBtn = (type: string, dataSource: ITableDataSource) => {
      let isDisabled = false;

      if (type === HandleType.Modify) {
        isDisabled = dataSource.ENDORSING;
      }

      return isDisabled;
    };

    const tableColumns: ColumnProps<ITableDataSource>[] = [
      {
        title: commonService.getNameByLng(this.props.resources, 'TID_Demand'),
        dataIndex: 'HANDLE_BTNS',
        key: 'HANDLE_BTNS',
        render: (types: string[], record: ITableDataSource) => {
          return (
            <div className="policy-inquiry__table-btns">
              {
                _.map(types, (type: string, index: number) => {
                  const btnClassName = ['policy-inquiry__table-btn'];

                  const isDisabled = setProcessBtn(type, record);
                  if (isDisabled) {
                    btnClassName.push('policy-inquiry__table-btn-disabled');
                  }
                  let btnTxt = '';
                  switch (type) {
                    case 'D':
                      btnTxt = commonService.getNameByLng(this.props.resources, 'TID_Check');
                      break;
                    case 'M':
                      btnTxt = commonService.getNameByLng(this.props.resources, 'TID_Correct');
                      break;
                    case 'R':
                      btnTxt = commonService.getNameByLng(this.props.resources, 'TID_Renew');
                      break;
                    default:
                      break;
                  }
                  return (
                    <button
                      type="button"
                      key={index}
                      className={btnClassName.join(' ')}
                      onClick={() => this.handleProcess(type, record)}
                      disabled={isDisabled}
                    >
                      {
                        btnTxt
                      }
                    </button>
                  );
                })
              }
            </div>
          );
        }
      },
      {
        title: commonService.getNameByLng(this.props.resources, 'TID_Products'),
        dataIndex: 'INS_TYPE_ID_TEXT',
        key: 'INS_TYPE_ID_TEXT'
      },
      {
        title: commonService.getNameByLng(this.props.resources, 'TID_Proposer_name'),
        dataIndex: 'APPLICANT_NAME',
        key: 'APPLICANT_NAME'
      },
      {
        title: commonService.getNameByLng(this.props.resources, 'TID_Insured_name'),
        dataIndex: 'INSURED_NAME',
        key: 'INSURED_NAME'
      },
      {
        title: commonService.getNameByLng(this.props.resources, 'TID_Order_number'),
        dataIndex: 'APPLY_NO',
        key: 'APPLY_NO'
      },
      {
        title: commonService.getNameByLng(this.props.resources, 'TID_Policy_CALI_number'),
        dataIndex: 'POLICY_NO',
        key: 'POLICY_NO',
        render: (text: any, record: any, index: number) => {
          return record.RENEWAL_MARK
            ? <div>{record.RENEWAL_MARK}</div>
            : (record.POLICY_NO ? <div>{record.POLICY_NO}</div> : <div>-</div>);
        }
      },
      {
        title: commonService.getNameByLng(this.props.resources, 'TID_Policy_effdate'),
        dataIndex: 'START_DATE',
        key: 'START_DATE',
        render: (text: any, record: any, index: number) => {
          return (
            <div style={{ textAlign: 'center' }}>
              <div>{record.START_DATE}</div>
              <div>{record.END_DATE}</div>
            </div>
          );
        }
      },
      {
        title: commonService.getNameByLng(this.props.resources, 'TID_Policy_status'),
        dataIndex: 'STATUS_TEXT',
        key: 'STATUS_TEXT'
        // render: (caseStatus: { text: string, status: string }) => {
        //   return (
        //     <span className={`policy-inquiry__case-status--${caseStatus.status}`}>
        //       {caseStatus.text}
        //     </span>
        //   );
        // }
      }
    ];

    // 手機欄位順序
    const tableColumnsMobile = [
      tableColumns[6],
      tableColumns[7],
      tableColumns[4],
      tableColumns[5],
      tableColumns[0],
      tableColumns[1],
      tableColumns[2],
      tableColumns[3]
    ];

    // const tableDataSource:any = [
    //   {
    //     key: '1',
    //     handle: ['明細', '續保', '批改'],
    //     INS_TYPE_NAME: '汽車險',
    //     APPLICANT_NAME: '陳小旺',
    //     INSURER_NAME: '陳小旺',
    //     APPLY_NO: 'NTAB20030001',
    //     POLICY_NO: '9099000139',
    //     VALID_PERIOD_START: '2020/03/10',
    //     // END_DATE: '2020/03/10',
    //     POLICY_STATUS: '1'
    //   }
    // {
    //   key: '2',
    //   handle: ['明細', '續保'],
    //   insType: '機車險',
    //   policyholderName: '陳小旺',
    //   insuredName: '陳小旺',
    //   guaranteeNumber: 'NTAB20030001',
    //   policyNumber: '',
    //   effectiveDate: '2020/03/10',
    //   caseStatus: {
    //     text: '處理中',
    //     status: 'handling'
    //   }
    // },
    // {
    //   key: '3',
    //   handle: ['明細'],
    //   insType: '住宅火險',
    //   policyholderName: '陳小旺',
    //   insuredName: '陳小旺',
    //   guaranteeNumber: 'NTAB20030001',
    //   policyNumber: '',
    //   effectiveDate: '2020/03/10',
    //   caseStatus: {
    //     text: '取消',
    //     status: 'cancel'
    //   }
    // }
    // ];

    /**
     * @description 取得可用查詢條件欄位名稱
     * @param fId 欄位代號
     * @param fieldInfos 查詢欄位成員 Model
    */
    const handleGetFName = (fId: string, fieldInfos: FieldContent[]) => {
      if (fieldInfos && fieldInfos.length > 0) {
        const field = _.find(fieldInfos, (fieldInfo: FieldContent) => fieldInfo.FID === fId);
        if (!field) return '';

        return field.FNAME;
      }

      return '';
    };

    /**
     * @description 建立險種查詢選項
    */
    const handleCreateInsTypeRadio = () => {
      if (this.state.fieldInfos.length === 0) return;

      const fieldInfo = _.find(this.state.fieldInfos, (info: FieldContent) => info.FID === FID.INS_TYPE_ID);
      if (!fieldInfo || !fieldInfo.FOPTION || typeof fieldInfo.FOPTION === 'string') return;

      return _.map(fieldInfo.FOPTION, (opt: FieldOptContent, index: number) => {
        // 針對「險種」選項處理多語系
        const find = valueTidMap.find(it => it.value === opt.VALUE);
        let optTxt = opt.TEXT;
        if (find) {
          optTxt = commonService.getNameByLng(this.props.resources, find.TID);
        }
        return (
          <div className={'element__radio-group' + (this.props.resources.lng === 'en' ? ' element__radio-group--full' : '')} key={index}>
            <label htmlFor={`ins-type-${opt.VALUE}-radio`}>
              <div className="element__radio">
                <Field type="radio" name="INS_TYPE" id={`ins-type-${opt.VALUE}-radio`} value={opt.VALUE} />
                <div className="element__radio-btn" />
              </div>
              <span>{optTxt}</span>
            </label>
          </div>
        );
      });
    };

    /**
     * @description 建立保單狀態
    */
    const handleCreatePolicyStatusRadio = () => {
      if (this.state.fieldInfos.length === 0) return;

      const fieldInfo = _.find(this.state.fieldInfos, (info: FieldContent) => info.FID === FID.POLICY_STATUS);
      if (!fieldInfo || !fieldInfo.FOPTION || typeof fieldInfo.FOPTION === 'string') return;

      return _.map(fieldInfo.FOPTION, (opt: FieldOptContent, index: number) => {
        // 針對「保單狀態」選項處理多語系
        const find = valueTidMap.find(it => it.value === opt.VALUE);
        let optTxt = opt.TEXT;
        if (find) {
          optTxt = commonService.getNameByLng(this.props.resources, find.TID);
        }
        return (
          <div className="element__radio-group" key={index}>
            <label htmlFor={`case-status-${opt.VALUE}-radio`}>
              <div className="element__radio">
                <Field type="radio" name="POLICY_STATUS" id={`case-status-${opt.VALUE}-radio`} value={opt.VALUE} />
                <div className="element__radio-btn" />
              </div>
              <span>{optTxt}</span>
            </label>
          </div>
        );
      });
    };

    return (
      <div className="policy-inquiry">
        <div className="template-container">
          <div className="template-content">
            <div className="policy-inquiry__title">{commonService.getNameByLng(this.props.resources, 'TID_Policy_inquiry')}</div>
            {this.state.codeTables.length > 0 && (
              <div className="policy-inquiry__desc">
                <ol>
                  {this.state.codeTables.map((data, index) => (
                    <li key={index}>{commonService.htmlParser(data.CODE_VALUE)}</li>
                  ))}
                </ol>
              </div>
            )}
            <div className="policy-inquiry__controls">
              <div className="policy-inquiry__controls-container">
                <Formik
                  innerRef={this.formikRef}
                  initialValues={formInitialValues}
                  onSubmit={this.handleFormSubmit}
                  enableReinitialize
                >
                  {({ resetForm }) => (
                    <Form>
                      <div className="policy-inquiry__controls-row">
                        {/* 生效日期 */}
                        <div className="element__form-group">
                          <div className="element__form-group-title">{commonService.getNameByLng(this.props.resources, 'TID_Policy_effdate')}</div>
                          <div className="element__form-group-content">
                            <ConfigProvider locale={this.props.resources.lng === 'en' ? enUS : zhTW}>
                              <DatePicker.RangePicker
                                name="EFFECTIVE_DATE"
                                className="element__input"
                                format="YYYY/MM/DD"
                              />
                            </ConfigProvider>
                          </div>
                        </div>
                        <p className="policy-inquiry__highlight-text">{commonService.getCodeMsg(this.state.UICodes, CodeId.U042)}</p>
                      </div>
                      <div className="policy-inquiry__controls-row">
                        {/* 險種 */}
                        <div className="element__form-group">
                          <div className="element__form-group-title">{commonService.getNameByLng(this.props.resources, 'TID_Products')}</div>
                          <div className="element__form-group-content">
                            {
                              handleCreateInsTypeRadio()
                            }
                          </div>
                        </div>
                      </div>
                      <div className="policy-inquiry__controls-row">
                        {/* 狀態 */}
                        <div className="element__form-group">
                          <div className="element__form-group-title">{commonService.getNameByLng(this.props.resources, 'TID_Policy_status_radio')}</div>
                          <div className="element__form-group-content">
                            {
                              handleCreatePolicyStatusRadio()
                            }
                          </div>
                        </div>
                      </div>
                      <div className="policy-inquiry__controls-btns">
                        <button type="submit" className="policy-inquiry__controls-inquire-btn">{commonService.getNameByLng(this.props.resources, 'TID_Query')}</button>
                        <button type="button" className="policy-inquiry__controls-reset-btn" onClick={() => this.handleResetForm(resetForm)}>{commonService.getNameByLng(this.props.resources, 'TID_Clear')}</button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
            <div className="policy-inquiry__table">
              <ConfigProvider locale={this.props.resources.lng === 'en' ? enUS : zhTW}>
                <Table
                  rowKey="TABLE_KEY"
                  columns={tableColumns}
                  pagination={this.handleGetPaginationTypes()}
                  dataSource={this.state.dataSources}
                  onChange={this.handleTableChange}
                />
              </ConfigProvider>
            </div>
            <div className="policy-inquiry__table-mobile">
              <ConfigProvider locale={this.props.resources.lng === 'en' ? enUS : zhTW}>
                <Table
                  rowKey="TABLE_KEY"
                  columns={tableColumnsMobile}
                  pagination={this.handleGetPaginationTypes()}
                  dataSource={this.state.dataSources}
                  onChange={this.handleTableChange}
                />
              </ConfigProvider>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: RootReducersState) => {
  return {
    resources: state.resources
  };
};

export default connect(mapStateToProps)(PolicyInquiry);
